import { connect } from 'react-redux';

import Component from '../components/js/TopSoccer';
import { ITopStates } from '../store';

const mapStateToProps = (state: ITopStates) => ({
  j1League: {
    isShow: state.soccerJ1League.isShow,
    games: state.soccerJ1League.games
  },
  jLeagueCup: {
    isShow: state.soccerJLeagueCup.isShow,
    games: state.soccerJLeagueCup.games
  },
  overseas: {
    isShow: state.soccerOverseas.isShow,
    players: state.soccerOverseas.players
  }
});

export default connect(mapStateToProps)(Component);
